import Styled from 'vue3-styled-components';

const CardBarChart2 = Styled.div`
@media only screen and (max-width: 379px){
    text-align: center
}
h1{
    margin-bottom: 5px;
}
@media only screen and (max-width: 1500px){
    h1{
        font-size: 22px;
    }
}
& > span{
    font-size: 14px;
    color: ${({ theme }) => theme['light-gray-color']};
}
p{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 21px 0 0 0;
    @media only screen and (max-width: 379px){
        justify-content: center;
    }
    .growth-upward, .growth-downward{
        display: inline-flex;
        align-items: center;
        ${({ theme }) => (!theme.rtl ? 'padding-right' : 'padding-left')}: 10px;
        font-weight: 600;

        i{
            line-height: 1;
        }
        svg{
            width: 15px;
        }
    }
    .growth-upward{
        color: ${({ theme }) => theme['success-color']};
        svg{
            color: ${({ theme }) => theme['success-color']};
        }
    }
    .growth-downward{
        color: ${({ theme }) => theme['danger-color']};
        svg{
            color: ${({ theme }) => theme['danger-color']};
        }
    }
    span{
        color: ${({ theme }) => theme['light-gray-color']};
        font-size: 13px;
        display: inline-block;
    }
}
`;

const OverviewSalesCard = Styled.div`
    display: flex;
    align-items: flex-start;
    padding: 5px 0 2px 0;
    .icon-box{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        width: 60px;
        border-radius: 10px;
        margin-right: 10px;
        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 10px;
        @media only screen and (max-width: 1399px){
            height: 40px;
            width: 40px;
        }
        @media only screen and (max-width: 991px){
            height: 60px;
            width: 60px;
        }
        img{
            max-width: 35px;
        }
        &.box-primary{
            background-color: ${({ theme }) => theme['primary-color']}10;
            path,
            circle{
                fill: ${({ theme }) => theme['primary-color']};
            }
        }
        &.box-success{
            background-color: ${({ theme }) => theme['success-color']}10;
            path,
            circle{
                fill: ${({ theme }) => theme['success-color']};
            }
        }
        &.box-secondary{
            background-color: ${({ theme }) => theme['secondary-color']}10;
            path,
            circle{
                fill: ${({ theme }) => theme['secondary-color']};
            }
        }
    }
    .card-chunk{
        h2{
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 2px;
            color: ${({ theme }) => theme['dark-color']};
        }
        span{
            color: ${({ theme }) => theme['light-gray-color']};
        }
        p{
            margin-top: 16px;
        }
    }
`;

export {
    CardBarChart2,
    OverviewSalesCard
};